// Payment Information
export const arcPaymentInformation = {
    type: "none",
    itemId: "paymentInformation",
    label: "<h2>Payment Information</h2>",
    className: "container",
    items: [
        // Payment Type
        {
            type: "none",
            itemId: "paymentTypeContainer",
            items: [
                {
                    type: "radioGroup",
                    itemId: "paymentType",
                    label: "Select payment type:",
                    className: "col-md-6",
                    required: true,
                    items: [
                        {
                            type: "radio",
                            itemId: "saveQuote",
                            parentItemId: "paymentType",
                            label: "Save Quote",
                            visible: false
                        },
                        {
                            type: "radio",
                            itemId: "premiumFinance",
                            parentItemId: "paymentType",
                            label: "Premium Financing",
                            visible: false
                        },
                        {
                            type: "radio",
                            itemId: "creditcard",
                            parentItemId: "paymentType",
                            label: "Credit Card"
                        },
                        {
                            type: "radio",
                            itemId: "ach",
                            parentItemId: "paymentType",
                            label: "ACH"
                        }
                    ]
                },
                {
                    type: "text",
                    itemId: "paymentAmount",
                    label: "Payment Amount",
                    className: "col-md-6",
                    disabled: true
                }
            ]
        },
        // Quote
        {
            type: "text",
            itemId: "quoteDescription",
            label: "Quote Message (ex. Name, Date, Additional Information)",
            required: true,
            visible: false
        },
        // All Payments
        {
            type: "none", itemId: "genericPayment", items: [
                { type: "text", itemId: "paymentFirstName", label: "First Name", className: "col-md-6", required: true },
                { type: "text", itemId: "paymentLastName", label: "Last Name", className: "col-md-6", required: true }
            ]
        },
        // Credit Card
        {
            type: "none", itemId: "creditCardPayment", items: [
                { type: "cc", itemId: "creditCardNumberInput", label: "Card Number", className: "col-md-9", required: true },
                { type: "text", itemId: "creditCardNumber", visible: false },
                { type: "text", itemId: "expirationDate", label: "Expiration (MM/YY)", className: "col-md-4", mask: "00/00", required: true },
                { type: "text", itemId: "verificationCode", label: "CVV", className: "col-md-4", mask: "0000", required: true },
                { type: "text", itemId: "paymentZipCode", label: "Zip Code", className: "col-md-4", mask: "00000", required: true }
            ]
        },
        // ACH
        {
            type: "none", itemId: "achPayment", items: [
                { type: "text", itemId: "accountNumber", label: "Account number", className: "col-md-6", required: true },
                { type: "text", itemId: "routingNumber", label: "Routing number", className: "col-md-6", required: true },
                {
                    type: "radioGroup", itemId: "bankClientType", className: "col-md-6", required: true, items: [
                        { type: "radio", itemId: "personalAccount", parentItemId: "bankClientType", label: "Personal Account" },
                        { type: "radio", itemId: "businessAccount", parentItemId: "bankClientType", label: "Business Account" }
                    ]
                },
                {
                    type: "radioGroup", itemId: "bankAccountType", className: "col-md-6", required: true, items: [
                        { type: "radio", itemId: "checkingAccount", parentItemId: "bankAccountType", label: "Checking Account" },
                        { type: "radio", itemId: "savingsAccount", parentItemId: "bankAccountType", label: "Savings Account" }
                    ]
                }
            ]
        },
        // Provider-specific helper text; ActionService sets its copy from the
        // paymentProvider returned by the rollout endpoint.
        {
            type: "none",
            itemId: "appliedPayVerbiage",
            className: "applied-pay-verbiage",
            visible: false,
            label: "<p>Enter your credit card or bank account information below to pay securely through Card Connect.</p>"
        },
        // Card Connect payment buttons.
        {
            type: "none", itemId: "paymentButtons", items: [
                { type: "submit", itemId: "backToRegister", label: "Back", className: "back-button text-left col-md-6", value: "backToRegister" },
                { type: "submit", itemId: "submitPayment", label: "Pay", className: "pay-button text-right col-md-6", value: "submitPaymentForm" }
            ]
        },
        // Applied Pay payment buttons — Pay (filled) stacked above Back (outline).
        {
            type: "none", itemId: "appliedPayButtons", className: "applied-pay-buttons", visible: false, items: [
                { type: "submit", itemId: "appliedPaySubmitPayment", label: "Pay", className: "applied-pay-pay-button", value: "submitPaymentForm" },
                { type: "submit", itemId: "appliedPayBackToRegister", label: "Back", className: "applied-pay-back-button", value: "backToRegister" }
            ]
        }
    ]
};
